import React, { useEffect, useState } from "react";


export const BloqueHomeAcciones = () => {
    const [cargaOferta, setCargaOferta] = useState('');

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/cargaoferta')).json();

        setCargaOferta(
            `${endpoint.url_base}${endpoint.url_variable}`
        )
        }
        asyncFunction();
    }, []);

    return (
        <div className="bloqueHomeAcciones bg-gray">
            <h1 className="title30black">OTRAS ACCIONES</h1>
            <div className="bloqueHomeAcciones--buttons">
                <a
                    className="btn-heroHome"
                    target="_blank"
                    href={cargaOferta}
                >
                    <button className="mt-half" style={{marginBottom: "2px"}}>
                        OFERTA DE LICITACION
                        <span className="btn-arrow-triangle-lime ml-half" />
                    </button>
                </a>
            </div>
        </div>
    );
};
